module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_brand1_m_jp.a8a84a0aac18c63c8f150998212fca1a.png";